import { render, staticRenderFns } from "./ProductsAlgolia.vue?vue&type=template&id=1225b08d&"
import script from "./ProductsAlgolia.vue?vue&type=script&lang=js&"
export * from "./ProductsAlgolia.vue?vue&type=script&lang=js&"
import style0 from "./ProductsAlgolia.vue?vue&type=style&index=0&id=1225b08d&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports